import { render } from "./Test.vue?vue&type=template&id=7395884e&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=7395884e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7395884e"]])

export default __exports__